import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMUserResource from 'resources/SMUserResource';
import SMUFavoriteListUpdateView from './SMUFavoriteListUpdateView';
import SMUFavoriteListDeleteView from './SMUFavoriteListDeleteView';
import SMUFavoriteView from './SMUFavoriteView';
import SMRoomResource from 'resources/SMRoomResource';
import SMRestClient from 'lib/SMRestClient';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMUFavoriteListDetailView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.canRequest = true;
    this.state = {
      user: this.props.user,
      listItems: [],
      totalCount: this.props.totalCount,
      links: this.props.links,
      currentPage: this.props.currentPage,
      display: this.props.display,
      isFavoriteListUpdateViewOpen: false,
      isFavoriteListDeleteViewOpen: false,
      isSMUFavoriteListSelectViewOpen: false,
      isMemoUpdated: false,
      favoriteList: {},

    };
  }

  updateEditFavoriteListState(state) {
    this.setState(state);
  }

  updateEditFavoriteMemoState(state) {
    this.setState(state);
  }

  removeFavorite() {
    this.requestResource(true);
  }

  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    this.applyResponsive();
    this.requestResource();
  }
  
  pageDidSelect(page, e) {
    e.preventDefault();
    this.setState({
      currentPage: page
    });
    setTimeout(()=>{
      this.requestResource();
    }, 1);
    SMTrackHelper.pageView();
  }

  requestResource(isAppend, callback){
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    let queries = {};
    if (this.state.currentPage != 1) queries["page"] = this.state.currentPage;
    queries["per_page"] = this.props.perPage;
    if (!isAppend) $(this.refs.mainCol).startLoading({modalOpacity:0});

    SMUserResource.getListedFavorites(this.props.user.username, this.props.favoriteListId, queries, (responses, error, xhr)=>{
      $(this.refs.mainCol).stopLoading();
      this.setState({display: SMConst.Display.Visible});
      if(error || !responses) return;
      const links = SMRestClient.getLinks(xhr);

      if (links["next"]) {
        this.canRequest = true;
      }
      let state = {
        favoriteList: responses,
        listItems: responses.favorites,
        totalCount: xhr.getResponseHeader("X-List-Total-Count"),
        links: links,
        currentPage: this.state.currentPage,
      };
      this.setState(state);
    });
  }

  showFavoriteListUpdateForm(e){
    if (e) e.preventDefault();
    this.setState({
      isFavoriteListUpdateViewOpen: true
    });
  }

  favoriteListUpdateViewDidClose() {
    this.setState({
      isFavoriteListUpdateViewOpen: false,
    });
  }

  showFavoriteListDeleteForm(e){
    if (e) e.preventDefault();
    this.setState({
      isFavoriteListDeleteViewOpen: true
    });
  }

  favoriteListDeleteViewDidClose() {
    this.setState({
      isFavoriteListDeleteViewOpen: false,
    });
  }

  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  renderFavoriteList() {
    let rows = [];

    for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
      const room = this.state.listItems[rowIndex];
      rows.push(
        <SMUFavoriteView
          delegate={this}
          user={this.props.user}
          key={room.id}
          room={room}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          favoriteList={this.state.favoriteList} // 現在のページのお気に入りリスト
          favoriteLists={this.state.favoriteLists}
          updateState={this.updateEditFavoriteMemoState.bind(this)}
          removeFavorite={this.removeFavorite.bind(this)}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      );
    }
    return rows;
  }

  renderPagerView() {
    return(
      <div className="ta-c">
        <SMSearchPagerView
          delegate={this}
          perPage={SMRoomResource.defaultPerPage()}
          totalCount={this.state.totalCount}
          currentPage={this.state.currentPage}
          links={this.state.links} />
      </div>
    );
  }

  render() {
    return (
      <div ref="mainCol" className="dashboard-favorite">
        <h2 className="dashboard-favorite__title">{this.state.favoriteList.name}</h2>
        <p className="dashboard-favorite__conunt">全{this.state.favoriteList.total_favorites}件</p>
        <p><a href={Routes.dashboard_favorite_lists_path()} className="link-hover-border dashboard-favorite__back">お気に入りリストに戻る</a></p>
        <div className="dashboard-favorite__setting">
          <p className="button-gray dashboard-favorite__setting-change" onClick={this.showFavoriteListUpdateForm.bind(this)}><a href="#" className="dashboard-favorite__setting-text">リスト名の変更</a></p>
          <p className="button-gray dashboard-favorite__setting-delete" onClick={this.showFavoriteListDeleteForm.bind(this)}><a href="#" className="dashboard-favorite__setting-text">削除</a></p>
        </div>
        {this.renderFavoriteList()}
        {this.renderPagerView()}
        <SMUFavoriteListUpdateView
          delegate={this}
          user={this.props.user}
          room={this.state.room}
          isOpen={this.state.isFavoriteListUpdateViewOpen}
          favoriteList={this.state.favoriteList}
          updateState={this.updateEditFavoriteListState.bind(this)} />
        <SMUFavoriteListDeleteView
          delegate={this}
          user={this.props.user}
          room={this.state.room}
          isOpen={this.state.isFavoriteListDeleteViewOpen}
          favoriteList={this.state.favoriteList} />
      </div>
    );
  }


}
SMUFavoriteListDetailView.defaultProps = {
  display: SMConst.Display.Visible
};
SMUFavoriteListDetailView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteListDetailView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteListDetailView.jsx